document.addEventListener('DOMContentLoaded',()=>{const overlay=document.querySelector('.search-overlay');document.querySelectorAll('[data-open-search]').forEach(b=>b.addEventListener('click',()=>{overlay?.classList.add('is-open');document.querySelector('[data-search-input]')?.focus()}));document.querySelector('[data-close-search]')?.addEventListener('click',()=>overlay?.classList.remove('is-open'));overlay?.addEventListener('click',e=>{if(e.target===overlay)overlay.classList.remove('is-open')});document.addEventListener('keydown',e=>{if(e.key==='Escape')overlay?.classList.remove('is-open')});document.querySelector('[data-backtop]')?.addEventListener('click',()=>window.scrollTo({top:0,behavior:'smooth'}));document.querySelector('[data-mobile-toggle]')?.addEventListener('click',()=>document.body.classList.toggle('mobile-open'));});

/* Flash Sale: works on storefront and when sections are added/reloaded in Theme Editor */
(function () {
  function initFlashSale(root) {
    if (!root) return;

    var timers = root.querySelectorAll('.fs-timer');
    timers.forEach(function (timer) {
      if (timer.dataset.fsTimerInitialized === 'true') return;

      var targetDateStr = timer.getAttribute('data-target-date');
      if (!targetDateStr) return;

      var targetDate = new Date(targetDateStr).getTime();
      if (Number.isNaN(targetDate)) return;

      timer.dataset.fsTimerInitialized = 'true';

      var daysEl = timer.querySelector('[data-days]');
      var hoursEl = timer.querySelector('[data-hours]');
      var minsEl = timer.querySelector('[data-mins]');
      var secsEl = timer.querySelector('[data-secs]');
      var interval;

      function updateTimer() {
        var distance = targetDate - Date.now();

        if (distance <= 0) {
          if (daysEl) daysEl.textContent = '00';
          if (hoursEl) hoursEl.textContent = '00';
          if (minsEl) minsEl.textContent = '00';
          if (secsEl) secsEl.textContent = '00';
          if (interval) clearInterval(interval);
          return;
        }

        var days = Math.floor(distance / (1000 * 60 * 60 * 24));
        var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);

        if (daysEl) daysEl.textContent = String(days).padStart(2, '0');
        if (hoursEl) hoursEl.textContent = String(hours).padStart(2, '0');
        if (minsEl) minsEl.textContent = String(minutes).padStart(2, '0');
        if (secsEl) secsEl.textContent = String(seconds).padStart(2, '0');
      }

      updateTimer();
      interval = setInterval(updateTimer, 1000);
      timer._fsInterval = interval;
    });

    root.querySelectorAll('.fs-promo-code').forEach(function (button) {
      if (button.dataset.fsPromoInitialized === 'true') return;
      button.dataset.fsPromoInitialized = 'true';

      button.addEventListener('click', function () {
        var code = button.getAttribute('data-code');
        var message = button.querySelector('.fs-copy-msg');
        if (!code) return;

        function showCopied() {
          if (!message) return;
          message.classList.add('show');
          setTimeout(function () { message.classList.remove('show'); }, 1500);
        }

        if (navigator.clipboard && window.isSecureContext) {
          navigator.clipboard.writeText(code).then(showCopied).catch(function () {});
        } else {
          var input = document.createElement('input');
          input.value = code;
          document.body.appendChild(input);
          input.select();
          document.execCommand('copy');
          document.body.removeChild(input);
          showCopied();
        }
      });
    });
  }

  function initAllFlashSales() {
    document.querySelectorAll('.flash-sale-section').forEach(initFlashSale);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllFlashSales);
  } else {
    initAllFlashSales();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var target = event.target;
    if (!target) return;

    if (target.classList && target.classList.contains('flash-sale-section')) {
      initFlashSale(target);
    } else if (target.querySelectorAll) {
      target.querySelectorAll('.flash-sale-section').forEach(initFlashSale);
    }
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var target = event.target;
    if (!target || !target.querySelectorAll) return;

    target.querySelectorAll('.fs-timer').forEach(function (timer) {
      if (timer._fsInterval) clearInterval(timer._fsInterval);
      timer._fsInterval = null;
      timer.dataset.fsTimerInitialized = 'false';
    });
  });
})();
